<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ ModeloContrato.cmcId ? 'Alterar modelo de contrato' : 'Novo modelo de contrato' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de modelos de
                                contrato</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item" v-if="User.garid == 0"><span>{{ ModeloContrato.cmcId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-file-document-edit-outline</v-icon></span>
                                <div>
                                    <h4>{{ ModeloContrato.cmcId ? 'Alterar modelo de contrato' : 'Novo modelo de contrato' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="ModeloContrato.cmcId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Nome do Modelo</label>
                                            <input v-model="ModeloContrato.cmcNome" type="text" class="form-control"
                                                placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2" v-if="User.garid == 0">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="ModeloContrato.cmcAtivo" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3" v-if="TipoPessoas != '' && User.garid == 0">
                                        <div class="form-group">
                                            <label>Tipo Pessoa</label>
                                            <select v-model="ModeloContrato.tpeId" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.tpeId"
                                                    :value="optionTipo.tpeId">{{ optionTipo.tpeNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2" v-if="TipoPessoas != '' && User.garid == 0">
                                        <div class="form-group">
                                            <label>Tipo Documento</label>
                                            <select v-model="ModeloContrato.tpdId" class="form-select form-control">
                                                <option :value=null>Selecione</option>
                                                <option v-for="optionTipo in TiposDocumentos" :key="optionTipo.tpdId"
                                                    :value="optionTipo.tpdId">{{ optionTipo.tpdNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3" v-if="ModeloContrato.tpeId == 1 && User.garid == 0">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <v-autocomplete v-model="ModeloContrato.garId" :items="ListGarantidorasGeral"
                                                item-title="garNomeEmpresa" item-value="garId" density="compact"
                                                variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhuma garantidora encontrada" />
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Dados Dinâmicos</label>
                                            <ckeditor :editor="editor" @ready="onReady"
                                                v-model="ModeloContrato.cmcTexto1" :config="$ckconfig"  :style="User.garid != 0
    ? { backgroundColor: '#f5f5f5', opacity: 0.6, height: '200px' } : {height: '300px'}"
                                                :disabled="User.garid != 0"></ckeditor>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Conteúdo Editável</label>
                                            <ckeditor :editor="editor" @ready="onReady"
                                                v-model="ModeloContrato.cmcTexto2" :config="$ckconfig"
                                                style="height: 800px;"></ckeditor>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Dados Dinâmicos</label>
                                            <ckeditor :editor="editor" @ready="onReady"
                                                v-model="ModeloContrato.cmcTexto3" :config="$ckconfig"
                                                :disabled="User.garid != 0" :style="User.garid != 0
    ? { backgroundColor: '#f5f5f5', opacity: 0.6, height: '200px' } : {height: '300px'}"></ckeditor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="ModeloContrato.cmcId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de modelos de contrato</h4>
                                    <a v-if="User.garid == 0" href="#" @click="EditNew()"
                                        class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="TipoPessoas != '' && ListGarantidorasGeral != ''">
                                <adm-data-table :headers="headers" :filter-source-headers="filtrosHeaders" :items="ModeloContratos" v-model="itemsSelected"
                                    :filter-options="{ garId: [{ title: 'GarantePay', value: null }, ...ListGarantidorasGeral.map(item => ({ title: item.garNomeEmpresa, value: item.garId }))] }"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina">
                                    <template #item-cmcAtivo="item">
                                        <span>{{ item.cmcAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tpeId="item">
                                        <span>{{item.tpeId != null ? TipoPessoas.filter(x => x.tpeId ==
                                            item.tpeId)[0].tpeNome : '' }}</span>
                                    </template>
                                    <template #item-garId="item">
                                        <span>{{item.garId != null ? ListGarantidorasGeral.filter(x => x.garId ==
                                            item.garId)[0].garNomeEmpresa : '' }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button v-if="User.garid == 0" type="button" class="gp-table-action gp-action-copy" title="Copiar modelo" @click="SelectedCmcId = item.cmcId; SelectedGarId = null; dialogReplace = true"><v-icon size="17">mdi-content-copy</v-icon></button>
        <button v-if="User.garid == 0" type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal de replicação do modelo -->
        <v-row justify="center">
            <v-dialog v-model="dialogReplace" persistent transition="dialog-bottom-transition" max-width="480">
                <v-card class="gp-replicate-dialog">
                    <v-card-title class="gp-replicate-dialog__header">
                        <span class="gp-replicate-dialog__icon"><v-icon size="21">mdi-content-copy</v-icon></span>
                        <span>
                            <strong>Replicar modelo de contrato</strong>
                            <small>Crie uma cópia deste modelo para outra garantidora.</small>
                        </span>
                    </v-card-title>
                    <v-card-text class="gp-replicate-dialog__body">
                        <v-form>
                            <v-container class="pa-0">
                                <v-row v-show="false">
                                    <v-col cols="12" md="4">
                                        <label>Id Contrato</label>
                                        <input v-model="SelectedCmcId" type="text" class="form-control"
                                            placeholder="Id" />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <div class="form-group mb-0">
                                        <label>Garantidora de destino <span class="text-danger">*</span></label>
                                        <v-autocomplete v-model="SelectedGarId" :items="ListGarantidorasGeral"
                                            item-title="garNomeEmpresa" item-value="garId" density="compact"
                                            variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                            no-data-text="Nenhuma garantidora encontrada" />
                                        <small class="gp-replicate-dialog__hint"><v-icon size="14">mdi-information-outline</v-icon> O modelo original será mantido sem alterações.</small>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="gp-replicate-dialog__actions">
                        <button type="button" class="btn btn-outline-secondary"
                            @click.prevent="dialogReplace = false">Cancelar</button>
                        <button type="button" class="btn btn-success"
                            @click.prevent="ReplicarContrato(SelectedCmcId, SelectedGarId)"><v-icon size="16">mdi-content-copy</v-icon> Replicar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>

</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
    name: 'CadastroModeloContratoView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        editor: DecoupledEditor,
        User: {
           garid: 0,
        },
        ModeloContrato: {
            cmcId: 0,
            cmcNome: '',
            cmcAtivo: '',
            cmcTexto1: '',
            cmcTexto2: '',
            cmcTexto3: '',
            tpeId: '',
            garId: null,
            tpdId: null,
        },
        ModeloContratos: [],
        selectedAtivo: null,
        headers: [
            { text: "Id", value: "cmcId", sortable: true, },
            { text: "Nome", value: "cmcNome", sortable: true, },
            { text: "Ativo", value: "cmcAtivo", sortable: true, },
            { text: "Tipo", value: "tpeId", sortable: true, },
            { text: "Garantidora", value: "garId", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        TipoPessoas: [],
        ListGarantidorasGeral: [],
        TiposDocumentos: [],
        dialogReplace: false,
        SelectedGarId: null,
        SelectedCmcId: '',
        ModeloContratoNovo: [],
    }),
    computed: {
        filtrosHeaders() {
            if (this.User.garid == 0) return this.headers;

            const filtrosRestritos = ['garId', 'tpeId', 'cmcAtivo'];
            return this.headers.filter(header => !filtrosRestritos.includes(header.value));
        }
    },
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        //edit
        EditNew() {
            this.EditView = true;
            this.ModeloContrato.cmcId = 0;
            this.ModeloContrato.cmcNome = '';
            this.ModeloContrato.cmcAtivo = '';
            this.ModeloContrato.cmcTexto1 = '';
            this.ModeloContrato.cmcTexto2 = '';
            this.ModeloContrato.cmcTexto3 = '';
            this.ModeloContrato.tpeId = '';
            this.ModeloContrato.garId = null;
            this.ModeloContrato.tpdId = null;
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.cmcId != '') {
                axios.get(`/Telas/ModelosContrato/GetById/` + item.cmcId)
                    .then(response => {
                        this.ModeloContrato = response.data;
                    });
            }
        },
        Add() {
            if (this.ModeloContrato.cmcNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ModeloContrato.cmcAtivo === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ModeloContrato.tpeId === '') {
                this.$mensagemAviso("Tipo Pessoa Obrigatório.")
            }
            else if (this.ModeloContrato.tpdId === '') {
                this.$mensagemAviso("Tipo Documento Obrigatório.")
            }
            else {
                axios.post(`/Telas/ModelosContrato/Add`, this.ModeloContrato)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        ReplicarContrato(_selectedCmcId, _selectedGarId) {
            axios.get(`/Telas/ModelosContrato/GetById/` + _selectedCmcId)
                .then(response => {
                    this.ModeloContratoNovo = response.data;
                    this.ModeloContratoNovo.cmcId = 0;
                    this.ModeloContratoNovo.garId = _selectedGarId;

                     axios.post(`/Telas/ModelosContrato/Add`, this.ModeloContratoNovo)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.dialogReplace = false;
                        }
                    });
                });

        },
        Put() {
            if (this.ModeloContrato.cmcNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ModeloContrato.cmcAtivo === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.ModeloContrato.tpeId === '') {
                this.$mensagemAviso("Tipo Pessoa Obrigatório.")
            }
            else if (this.ModeloContrato.tpdId === '') {
                this.$mensagemAviso("Tipo Documento Obrigatório.")
            }
            else {
                axios.put(`/Telas/ModelosContrato/Update`, this.ModeloContrato)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        EditCancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        //edit
        DeleteGrid(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.cmcId;
                        axios.delete(`/Telas/ModelosContrato/Delete/${param1}`)
                            .then(response => {
                                if (response.stacmc == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.Get();
                                }
                            });
                    }
                });
        },
        async Get() {
            
            this.EditView = false;
            await axios.get(`/Telas/ModelosContrato/GetDados`)
               .then(response => {
                this.ModeloContratos = response.data.modelosContratos;
                this.TipoPessoas = response.data.tiposPessoas;
                this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                        b.garNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                this.TiposDocumentos = response.data.tipoDocumentos;
                this.User.garid = response.data.garId;
           });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
.gp-replicate-dialog { overflow: hidden; border: 1px solid #e1d9cd; border-radius: 14px !important; background: #fffdf9; box-shadow: 0 18px 50px rgba(16, 42, 90, .18) !important; }
.gp-replicate-dialog__header { display: flex; align-items: center; gap: 11px; padding: 16px 18px; border-bottom: 1px solid #e8e1d7; background: #fcf8f2; color: #102a5a; white-space: normal; }
.gp-replicate-dialog__header > span:last-child { display: flex; min-width: 0; flex-direction: column; gap: 2px; }
.gp-replicate-dialog__header strong { font-size: 14px; font-weight: 800; line-height: 1.3; }
.gp-replicate-dialog__header small { color: #6f7b8f; font-size: 10.5px; font-weight: 500; line-height: 1.35; }
.gp-replicate-dialog__icon { width: 36px; height: 36px; display: grid; flex: 0 0 36px; place-items: center; border-radius: 10px; background: #fff0df; color: #e77900; }
.gp-replicate-dialog__body { padding: 20px 18px 18px !important; }
.gp-replicate-dialog__body label { display: block; margin-bottom: 6px; color: #465168; font-size: 11px; font-weight: 750; }
.gp-replicate-dialog__hint { display: flex; align-items: center; gap: 4px; margin-top: 8px; color: #748095; font-size: 10px; }
.gp-replicate-dialog__actions { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 18px 16px; border-top: 1px solid #eee7dd; }
.gp-replicate-dialog__actions .btn { min-width: 94px; display: inline-flex; align-items: center; justify-content: center; gap: 5px; margin: 0; padding: 7px 12px; border-radius: 9px; font-size: 11.5px; font-weight: 750; }
@media (max-width: 575.98px) { .gp-replicate-dialog__actions { align-items: stretch; flex-direction: column-reverse; } .gp-replicate-dialog__actions .btn { width: 100%; } }
</style>
